<app-count-box
  mode="view"
  icon="fas fa-map-location-dot"
  [styleClass]="styleClass"
  [text]="text"
  [label]="title"
  [count]="store.count()"
  severity="secondary" />
